import {
  GET_PRODUCT_TEMPLATES_LOADING,
  GET_PRODUCT_TEMPLATES_SUCCESS,
  GET_PRODUCT_TEMPLATES_FAILED,
} from "../types";

const initialState = {
  loading: false,
  templates: [],
  error: null,
  totalRecords: 0,
  currentPage: 0,
  totalPages: 0,
};

const getProductTemplatesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PRODUCT_TEMPLATES_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_PRODUCT_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        templates: action.payload.content || action.payload.data || [],
        totalRecords: action.payload.totalElements || action.payload.totalRecords || 0,
        currentPage: action.payload.pageable?.pageNumber || action.payload.currentPage || 0,
        totalPages: action.payload.totalPages || 0,
        error: null,
      };
    case GET_PRODUCT_TEMPLATES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
        templates: [],
        totalPages: 0,
        currentPage: 0,
        totalRecords: 0,
      };
    default:
      return state;
  }
};

export default getProductTemplatesReducer;